import getDeltaAbsolute from "../../../animate/utils/coordinates/get-delta-absolute";
import getDeltaContinuous from "../../../animate/utils/coordinates/get-delta-continuous";
import getScrollContinuous from "../../../animate/utils/coordinates/get-scroll-continuous";
import getScrollDefault from "../../../animate/utils/coordinates/get-scroll-default";

/**
 * Set the function that computes the percents for scroll trigger
 * @param {String} method
 * @returns
 */
const setTriggerPercentsScroll = (method) => {
  /** Parallax */
  if (method === "continuous" || method === "parallax") {
    return getScrollContinuous;
  }

  /** Delta (relative) */
  if (method === "delta_-_continuous") {
    return getDeltaContinuous;
  }

  /** Delta absolute */
  if (method === "delta") {
    return getDeltaAbsolute;
  }

  /** Default */
  if (method === "default") {
    return getScrollDefault;
  }
};

export default setTriggerPercentsScroll;
